import React from 'react';
import TemuSyncProgressBar from '@/temu-platform/components/TemuSyncProgressBar';
import { useTemuSyncJobs } from '@/temu-platform/context/TemuSyncJobContext';

/**
 * 全局同步进度：仅展示未被页面槽位认领的任务（切到其他页时仍可见）。
 * 样式与页面内槽位共用 TemuSyncProgressBar。
 */
export default function TemuGlobalSyncProgress() {
  const { globalBars, cancelTrack, cancellingIds } = useTemuSyncJobs();

  if (!globalBars.length) return null;

  return (
    <div className="temu-global-sync" aria-live="polite">
      {globalBars.map((progress) => (
        <TemuSyncProgressBar
          key={progress.trackId}
          progress={progress}
          onCancel={
            progress.status === 'queued' || progress.status === 'running'
              ? () => cancelTrack(progress.trackId)
              : undefined
          }
          cancelling={cancellingIds.has(progress.trackId)}
        />
      ))}
    </div>
  );
}
